var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRenewGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "renew_green",
    transform: "translate(12065 -992)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12837",
    "data-name": "Rectangle 12837",
    width: 24,
    height: 24,
    transform: "translate(-12065 992)",
    fill: "#2e8b57",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "replay_black_24dp",
    d: "M12,5V2.21a.5.5,0,0,0-.85-.35L7.35,5.65a.5.5,0,0,0,0,.71l3.79,3.79A.506.506,0,0,0,12,9.79V7a6,6,0,1,1-5.94,6.85,1,1,0,0,0-1.98.28A8.006,8.006,0,1,0,12,5Z",
    transform: "translate(-12065.071 992.292)",
    fill: "#2e8b57"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewGreen);
export default __webpack_public_path__ + "static/media/renew_green.cff7eed5035344cfae6166e92aa6d73f.svg";
export { ForwardRef as ReactComponent };